export const ebayApp = {
  id: 17,
  name: "ebay",
  label: "Ebay",
  showTestConnection: true,
  useOAuth: true,
  logo: process.env.BASE_URL + "media/shopLogos/ebay.png",
  areaBlacklist: ["reporting"],
  environmentVariables: {
    oauth: {
      client_id: process?.env?.VUE_APP_EBAY_APP_CLIENT_ID,
      redirect_uri: process?.env?.VUE_APP_EBAY_APP_REDIRECT_URL,
      response_type: process?.env?.VUE_APP_EBAY_APP_RESPONSE_TYPE,
      scope: process?.env?.VUE_APP_EBAY_APP_SCOPE,
      // Forces the eBay login screen even when a session already exists,
      // otherwise a second integration silently reuses the logged in account
      prompt: "login",
      migration_redirect_uri: process?.env?.VUE_APP_EBAY_APP_MIGRATION_REDIRECT_URL
    },
    presetId: process.env?.VUE_APP_SCM_APP_EBAY_PRESET_ID,
    testWorkflows: {
      salesOrder: process.env?.VUE_APP_SCM_APP_EBAY_TEST_ORDER_WORKFLOW_ID,
      stock: process.env?.VUE_APP_SCM_APP_TEST_STOCK_WORKFLOW_ID,
      tracking: process.env?.VUE_APP_SCM_APP_TEST_TRACKING_WORKFLOW_ID
    },
    testBatchWorkflows: {
      salesOrder:
        process.env?.VUE_APP_SCM_APP_EBAY_TEST_BATCH_ORDER_WORKFLOW_ID,
      tracking: process.env?.VUE_APP_SCM_APP_TEST_BATCH_TRACKING_WORKFLOW_ID
    },
    CFLDataSetId: process.env.VUE_APP_SCM_APP_EBAY_REPORTING_CFL_DATASET_ID,
    syncBatchWorkflowId:
      process.env.VUE_APP_SCM_APP_EBAY_REPORTING_SYNC_BATCH_WORKFLOW_ID
  }
};
